import { Button } from "antd";
import { useTranslation } from "react-i18next";

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const switchLanguage = () => {
    void i18n.changeLanguage(i18n.language === "zh-TW" ? "en-US" : "zh-TW");
  };

  return (
    <Button className="rel w:32 h:32" type="text" onClick={switchLanguage}>
      <div className="abs bottom:2 right:2 fg:gray-40 leading:1 w:16 h:16 text:14 b:1|solid|gray-40 flex jc:center ai:center">
        {i18n.language === "zh-TW" ? "EN" : "中"}
      </div>
      <div className="abs pt:2 w:20 h:20 top:2 left:2 text:16 bg:gray-40 fg:white flex jc:center ai:center">
        {i18n.language === "zh-TW" ? "中" : "EN"}
      </div>
    </Button>
  );
};
